// extracted by mini-css-extract-plugin
export var attribution = "_cc-4";
export var authorName = "_cc-5";
export var quote = "_cc-3";
export var testimonial = "_cc-2";
export var trustedBy = "_cc-0";
export var trustedByLabel = "_cc-1";